import * as React from 'react'

import 'rc-menu/assets/index.css'
import moment from 'moment'
//Weather
import { IOrgObj, WeatherDTO, WeatherQueryParams } from '../../types'
interface WeatherProps {
  orgServiceAreaName: string
  orgId: string
  orgName: string
  userName: string
  isAdmin: boolean
  weather: WeatherDTO
  getWeather: (orgId: string, queryParams: WeatherQueryParams) => void
}
const Weather = (props: WeatherProps) => {
  React.useEffect(() => {
    if (props.orgServiceAreaName !== '') {
      props.getWeather(`${props.orgId}`, { address: `${props.orgServiceAreaName}` })
    }
  }, [props.orgServiceAreaName])
  const getIconValue = props.weather ? props.weather.icon : ''
  if (!getIconValue) {
    return <></>
  }
  const iconLink = `${'https://openweathermap.org/img/wn/' + `${getIconValue}` + '.png'}` //get icon value from response

  if (props.weather) {
    return (
      <div className='flex items-center cursor--pointer' title='Weather'>
        <img width='50px' height='50px' src={iconLink} /> {'&emsp;' + props.weather ? props.weather.main : ''}{' '}
        {'&emsp;' + props.weather ? props.weather.temp : ''}
        {' \u2109'}
      </div>
    )
  }
  return <div />
}
export default Weather



// WEBPACK FOOTER //
// ./src/components/navigation/Weather.tsx